import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthPayload } from "../../engine/models/models";

@Injectable({ providedIn: "root" })

export class LoginService {
  constructor(private http: HttpClient) {
  }

  login(loginModel: AuthPayload): Observable<AuthPayload> {
    return this.http.post<AuthPayload>(`${environment.api}/api/authentication`, loginModel);
  }
  requestAuth(token: string): Observable<AuthPayload> {
    return this.http.get<AuthPayload>(`${environment.api}/api/authentication?token=${token}`);
  }
}
